<template lang="pug">
  v-app
    v-app-bar(app, color="primary", dark, height=56, elevation=0)
      v-avatar.mx-2
        img(src="favicon.ico")
      v-toolbar-title.text-truncate.d-block.d-md-none {{breadcrumbs.slice(-1)[0].text || 'KiraFan Assets'}}
      v-toolbar-title.text-truncate.d-none.d-md-block KiraFan Assets
      v-spacer
      DownloadStatus

    v-content(v-if="!ok", style="min-height: 100vh")
      .pa-8.text-center
        v-progress-circular(indeterminate=true, color="primary")
        .pa-2.caption
          span Loading asset bundle...

    v-content(v-else, style="min-height: 100vh")
      Scroller(icon=60)
        v-breadcrumbs.pa-4(:items="breadcrumbs", divider="/", style="flex-wrap: nowrap")
          template(v-slot:item="{item}")
            v-breadcrumbs-item(:to="'/'+item.path", exact=true)
              v-btn(v-if="!item.text", icon, small, to="/"): v-icon mdi-home
              span(v-else) {{item.text}}

      v-divider

      .d-block.d-md-none
        .py-2
        List(:path="path", v-if="assetBundle.isDir(path)")
        File(:path="path", v-else)
        .py-2
      
      .d-none.d-md-flex
        template(v-for="breadcrumb, i in breadcrumbs")
          v-divider(vertical, v-show="i >= breadcrumbs.length - column")
          div(style="height: calc(100vh - 117px); overflow-y: scroll", v-show="i >= breadcrumbs.length - column"
            :style="{width: i == breadcrumbs.length - 1 ? `calc(100% - (360px + 1px) * ${column - 1 < i ? column - 1: i})` : `360px`}")

            .py-2
            List(:path="breadcrumb.path", v-if="assetBundle.isDir(breadcrumb.path)")
            File(:path="breadcrumb.path", v-else)
            .py-2

      Menu

    v-footer(dark, padless)
      v-card.primary(tile, style="width: 100%")
        .ma-auto.pa-6(style="max-width: 768px")
          v-row
            v-col(cols=12, sm=6)
              v-card-title.px-0 KiraFan Assets
              v-card-subtitle.px-0 Kirara Fantasia Assets Browser
              v-card-text.px-0.py-1
                | Contribute to KiraFan Assets on
                a.white--text(href="https://gitlab.com/kirafan/assets/browser", target="_blank")
                  v-icon.px-1 mdi-gitlab
                  | GitLab
                | .

            v-col(cols=6, sm=3)
              v-card-title.px-0 Projects
              v-card-text.px-0.py-1: a.white--text(href="https://wiki.kirafan.moe", target="_blank")
                | KiraFan Wiki
              v-card-text.px-0.py-1: a.white--text(href="https://calc.kirafan.moe", target="_blank")
                | KiraFanCalc

            v-col(cols=6, sm=3)
              v-card-title.px-0 Contact
              v-card-text.px-0.py-1: a.white--text(href="https://twitter.com/nilcric", target="_blank")
                v-icon.px-1 mdi-twitter
                | Circle Lin

</template>

<script>
import List from '@/components/List';
import File from '@/components/File';
import Divider from '@/components/Divider';
import Scroller from '@/components/Scroller';
import Menu from '@/components/Menu';
import DownloadStatus from '@/components/DownloadStatus';
import assetBundle from '@/assetBundle';

export default {
  name: 'App',

  components: { List, File, Divider, Scroller, Menu, DownloadStatus },

  data() {
    return {
      ok: false,
      assetBundle,
    };
  },

  computed: {
    path() {
      let p = this.$route.path;
      p = p.replace(/\/\/*/g, '/');
      p = p.replace(/^\//g, '');
      p = p.replace(/\/$/g, '');
      return p;
    },

    breadcrumbs() {
      const paths = this.path == '' ? [''] : ('/' + this.path).split('/');
      let items = [];
      for (let i in paths) {
        items.push({
          text: paths[i],
          path: paths.slice(1, parseInt(i) + 1).join('/'),
        });
      }
      return items;
    },

    column() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 1;
        case 'sm': return 1;
        case 'md': return 2;
        case 'lg': return 3;
        case 'xl': return 4;
      }
      return 0;
    },
  },

  mounted() {
    this.$root.$on('ok', x => {
      this.ok = x;
    });
  },
};
</script>

<style>
.v-list-item__action {
  min-width: 0 !important;
  margin: auto;
}
</style>
